export class UserWallet {
  idUserWallet: number;
  idUser: number;
  idBlockchainAddress: number;
  address: string;
  tag: string | null;

  constructor(
    idUserWallet: number,
    idUser: number,
    idBlockchainAddress: number,
    address: string,
    tag: string | null,
  ) {
    this.idUserWallet = idUserWallet;
    this.idUser = idUser;
    this.idBlockchainAddress = idBlockchainAddress;
    this.address = address;
    this.tag = tag;
  }

  static fromRaw(raw: any): UserWallet {
    return new UserWallet(
      raw.idUserWallet,
      raw.idUser,
      raw.idBlockchainAddress,
      String(raw.address),
      raw.tag,
    );
  }

  clone(): UserWallet {
    return new UserWallet(
      this.idUserWallet,
      this.idUser,
      this.idBlockchainAddress,
      this.address,
      this.tag,
    );
  }

  toPayload(tagIsNull: boolean): any {
    const payload: any = {
      idUser: this.idUser,
      idBlockchainAddress: this.idBlockchainAddress,
      address: this.address,
      tag: this.tag,
    };
    if (tagIsNull) {
      payload.tag = null;
    }
    if (this.idUserWallet !== 0) {
      payload.idUserWallet = this.idUserWallet;
    }
    delete payload.idUser;
    return payload;
  }
}
